
// selecting elements
const body = document.querySelector("body") as HTMLBodyElement;
const btn = document.querySelector("#btn") as HTMLButtonElement;
const title = document.querySelector(".title") as HTMLElement;
const allText = document.querySelectorAll("*") as NodeListOf<HTMLElement>;
const navLinks = document.querySelectorAll("nav a") as NodeListOf<HTMLElement>;
const featureCards = document.querySelectorAll(".feature-card") as NodeListOf<HTMLElement>;
const galleryItems = document.querySelectorAll(".gallery-item") as NodeListOf<HTMLElement>;
const form = document.querySelector(".contact-form") as HTMLFormElement;

// Define random color Generator function
function randomColorGen() {
  const r = Math.round(Math.random() * 255);
  const g = Math.round(Math.random() * 255);
  const b = Math.round(Math.random() * 255);

  return `rgb(${r}, ${g}, ${b})`;
}


// Change colors for all elements
btn.addEventListener("click", () => {
  // Change background color of body and container
  // container.style.backgroundColor = randomColorGen();
  // body.style.background = `linear-gradient(135deg, ${randomColorGen()}, ${randomColorGen()}, ${randomColorGen()})`

  // Change text color of all elements
  allText.forEach((el) => {
    el.style.color = randomColorGen();
  });

  // Change button colors
  btn.style.backgroundColor = randomColorGen();
  btn.style.color = randomColorGen();

  // Change specific element colors
  title.style.color = randomColorGen();

  // Change nav link colors
  navLinks.forEach((link) => {
    link.style.backgroundColor = randomColorGen();
  });

  // Change feature card colors
  featureCards.forEach((card) => {
    card.style.backgroundColor = randomColorGen();
  });

  // Change gallery item colors
  galleryItems.forEach((item) => {
    item.style.backgroundColor = randomColorGen();
  });

  // Change form colors
  form.style.backgroundColor = randomColorGen();
});
